<template>
    <div>
      <table class="table table-striped table-bordered">
        <thead>
          <tr>
            <th>Subject</th>
            <th>Teacher</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in studentItems" :key="item.id">
            <td>{{ item.subject_name }}</td>
            <td>{{ item.teacher_name }}</td>
            <td>
              <!-- Delete button with Bootstrap styles and icons -->
              <button class="btn btn-danger" @click="confirmDelete(item.id, index)">
                <i class="bi bi-trash-fill"></i> Delete
              </button>
            </td>
          </tr>
        </tbody>
      </table>
  
      <!-- Success message display -->
      <div v-if="successMessage" class="alert alert-success" role="alert">
        <i class="bi bi-check-circle-fill"></i> {{ successMessage }}
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  
  export default {
    name: 'StudentAddItem',
  
    props: {
      studentId: {
        type: Number,
        required: true,
      },
    },
  
    data() {
      return {
        studentItems: [], // Array to store fetched student items
        successMessage: '', // Variable to store success message
      };
    },
  
    created() {
      this.fetchStudentItems();
    },
  
    methods: {
      // Fetch student items
      fetchStudentItems() {
        axios.get(`/get-student-items/${this.studentId}`)
          .then(response => {
            this.studentItems = response.data;
          })
          .catch(error => {
            console.error("Error fetching student items:", error);
          });
      },
  
      // Confirm delete and call delete item
      confirmDelete(itemId, index) {
        const confirmed = window.confirm("Are you sure you want to delete this item?");
        if (confirmed) {
          this.deleteItem(itemId, index);
        }
      },
  
      // Delete item directly
      deleteItem(itemId, index) {
        // Send delete request to the backend
        axios.delete(`/delete-student-item/${itemId}`)
          .then(response => {
            // Remove the item from the array after successful deletion
            this.studentItems.splice(index, 1);
            // Set success message from backend response
            this.successMessage = response.data.message;
  
            // Clear success message after 2 seconds
            setTimeout(() => {
              this.successMessage = '';
            }, 2000);
          })
          .catch(error => {
            console.error("Error deleting student item:", error);
          });
      },
    },
  };
  </script>
  
  <style scoped>
  .table {
    margin-top: 20px;
  }
  
  .alert {
    margin-top: 20px;
  }
  </style>
  